import { generateDraftFrames } from 'mocks/server/data/draftFrames';
import { generateDraftLinkedAssets } from 'mocks/server/data/draftLinkedAssets';
import { baseFrame, frames } from 'mocks/server/data/frames';
import { baseLinkedAsset, linkedAssets } from 'mocks/server/data/linkedAssets';
import LocalStorageManager from 'mocks/server/localStorageManager';
import { populateDraftsStore, populateLiveEntityStore } from 'mocks/server/utils/entityUtils';
import { generateEntities } from 'mocks/server/utils/generateEntities';
import {
  IBaseEntity,
  IDraftFrame,
  IDraftLinkedAsset,
  ILiveFrame,
  ILiveLinkedAsset,
} from 'types/detailsEntityType';

export const clearAllMockData = (
  removedEntities: LocalStorageManager<IBaseEntity>,
  draftFrameStore: LocalStorageManager<IDraftFrame>,
  draftLinkedAssetStore: LocalStorageManager<IDraftLinkedAsset>,
  frameStore: LocalStorageManager<ILiveFrame>,
  linkedAssetStore: LocalStorageManager<ILiveLinkedAsset>
) => {
  removedEntities.clear();
  draftFrameStore.clear();
  draftLinkedAssetStore.clear();
  frameStore.clear();
  linkedAssetStore.clear();
};

export const populateMockData = (
  removedEntities: LocalStorageManager<IBaseEntity>,
  draftFrameStore: LocalStorageManager<IDraftFrame>,
  draftLinkedAssetStore: LocalStorageManager<IDraftLinkedAsset>,
  frameStore: LocalStorageManager<ILiveFrame>,
  linkedAssetStore: LocalStorageManager<ILiveLinkedAsset>
) => {
  const generatedDraftFrames = generateDraftFrames();
  const generatedDraftLinkedAssets = generateDraftLinkedAssets();
  const generatedLiveFrames = generateEntities(baseFrame, frames);
  const generatedLinkedAssets = generateEntities({ ...baseLinkedAsset() }, linkedAssets);

  populateDraftsStore(generatedDraftFrames, removedEntities, draftFrameStore);
  populateDraftsStore(generatedDraftLinkedAssets, removedEntities, draftLinkedAssetStore);
  populateLiveEntityStore(generatedLiveFrames, frameStore);
  populateLiveEntityStore(generatedLinkedAssets, linkedAssetStore);
};
